import { AppBar, Button, IconButton, Slide, Toolbar, withStyles } from '@material-ui/core';
import { AccountCircle, ArrowDropDown, Menu } from '@material-ui/icons';
import React, { useEffect } from 'react';
import EskassaWideLogo from '../../assets/eskassa_wide.svg';
import { HOME_URL } from '../../const/routes';
import RenderBreakpoint from '../common/breakpoints/RenderBreakpoint';
import CommonLink from '../common/CommonLink';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

export const styles = theme => ({
  appbar: {
    boxShadow: 'none',
  },
  toolbar: {
    padding: theme.spacing(0, 1, 0, 1),
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  menuIcon: {
    color: 'black',
  },
  logo: {
    height: 50, // fixed amount < application min height
  },
  logoImage: {
    width: 'auto',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      width: 70,
    },
  },
  dinkassa: {
    fontSize: 24,
    margin: 0,
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
  toolbarSpacer: {
    flex: 1,
  },
  accountItemButton: {
    padding: 0,
  },
  accountItemContent: {
    display: 'flex',
    fontSize: 16,
    alignItems: 'center',
    textTransform: 'none',
    color: 'black',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
});

const AppToolbar = ({ classes, visible, onShowMainMenu, onShowAccountMenu, user }) => {
  useEffect(() => {
    if (user && window.Beamer) {
      window.initBeamer(user);
    }
  }, [user]);
  
  return (
    <Slide in={visible} direction="down">
      <AppBar className={classes.appbar} position="fixed">
        <Toolbar className={classes.toolbar}>
          <RenderBreakpoint mobile>
            <IconButton
              className={classes.menuIcon}
              onClick={onShowMainMenu}>
              <Menu />
            </IconButton>
          </RenderBreakpoint>
          
          <div className={classes.logo}>
            <CommonLink to={HOME_URL}>
              <img
                className={classes.logoImage}
                src={EskassaWideLogo}
                alt="Eskassa wide logo"
              />
            </CommonLink>
          </div>
          
          <div className={classes.toolbarSpacer} />
          
          <span className={classes.dinkassa}>d i n k a s s a</span>
          
          <div className={classes.toolbarSpacer} />
          
          <Button
            className={classes.accountItemButton}
            variant="text"
            color="secondary"
            onClick={onShowAccountMenu}
          >
            <div className={classes.accountItemContent}>
              <AccountCircle color="inherit" />&nbsp;
              {user && user.UserName
                ? user.UserName
                : <FormattedMessage
                  id="toolbar.account"
                  defaultMessage="Account"
                />}
              &nbsp;
              <ArrowDropDown color="inherit" />
            </div>

          </Button>
        </Toolbar>
      </AppBar>
    </Slide>
  );
};

AppToolbar.propTypes = {
  classes: PropTypes.object,
  visible: PropTypes.bool,
  onShowMainMenu: PropTypes.func,
  onShowAccountMenu: PropTypes.func,
  user: PropTypes.object,
};

const decorate = compose(
  withStyles(styles),
  connect(
    store => ({
      user: store.user.profile,
    }),
    null,
  ),
);

export default decorate(AppToolbar);
